import { Component, ViewChild, OnDestroy } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ImageViewerController } from 'ionic-img-viewer';
import { CardVideoComponent } from '../../components/card-video/card-video';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-cofre',
  templateUrl: 'busqueda-tesoro-cofre.html',
})
export class BusquedaTesoroCofrePage implements OnDestroy {

  _imageViewerCtrl: ImageViewerController;
  @ViewChild(CardVideoComponent) cardVideo: CardVideoComponent;
  nivel: any;
  tesoro: any;
  audio: any;
  isPlay: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    imageViewerCtrl: ImageViewerController,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
  ) {
    this.nivel = navParams.get('nivel');
    this._imageViewerCtrl = imageViewerCtrl;
  }

  async ionViewDidLoad() {
    this.tesoro = await this.busquedaTesoroProvider.buscaTesoro(this.nivel.tesoro);

    // this.tesoro = {
    //   tipo: 'IMG',
    //   contenido: 'https://gameif.media/image/logo.png'
    // }
    // this.tesoro = {
    //   tipo: 'AUDIO',
    //   contenido: 'https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_2MG.mp3'
    // }
    // this.tesoro = {
    //   tipo: 'VIDEO',
    //   contenido: 'https://www.w3schools.com/html/mov_bbb.mp4'
    // }

    if(this.tesoro.tipo === 'AUDIO') {
      this.preloadAudio();
    }
  }

  ngOnDestroy(): void {
    if(this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }

  exit() {
    this.navCtrl.pop();
  }

  verImagen(recurso) {
    const imageViewer = this._imageViewerCtrl.create(recurso);
    imageViewer.present();
  }

  verVideo() {
    this.cardVideo.reproduceVideo();
  }

  floor(time) {
    if(isNaN(time)) return '00:00';

    let pad = function(num, size) { return ('000' + num).slice(size * -1); };
    let minutos  = Math.floor(time / 60);
    let segundos = Math.floor( time - minutos * 60);

    return pad(minutos, 2)+':'+pad(segundos, 2);
  }

  sec2time(timeInSeconds) {
    let pad = function(num, size) { return ('000' + num).slice(size * -1); };
    let time: any = parseFloat(timeInSeconds).toFixed(3);
    let hours = Math.floor(time / 60 / 60);
    let minutes = Math.floor(time / 60) % 60;
    let seconds = Math.floor(time - minutes * 60);
    let milliseconds = time.slice(-3);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + ',' + pad(milliseconds, 3);
  }

  preloadAudio() {
    this.audio = new Audio();
    this.audio.src = this.tesoro.contenido;
    this.audio.preload = "auto";
    this.audio.load();


    this.audio.addEventListener("loadedmetadata", () => {
      this.audio.currentTime;
    });

    this.audio.addEventListener("timeupdate", (e) => this.audio.currentTime );

    this.audio.addEventListener("ended", () => {
      console.log('fin')
      this.isPlay = false;
    });
  }

  escuchaAudio() {
    if(!this.isPlay) {
      this.audio.play();
      this.isPlay = true;
    } else {
      this.audio.pause();
      this.isPlay = false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-cofre/busqueda-tesoro-cofre.ts